/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from '@hooks/useAuth';
import { usePartner } from '@contexts/PartnerContext';
import useCarehomePartners from '@hooks/useCarehomePartners';

const CareHomePartnerList: React.FC = () => {
  const { selectedPartnerId, setSelectedPartnerId } = usePartner();
  const {
    carehomePartnerList,
    selectedPartnerId: partnerId,
    error,
  } = useCarehomePartners();
  const { switchPartner } = useAuth();
  const location = useLocation();

  useEffect(() => {
    setSelectedPartnerId(partnerId);
    if (partnerId) {
      switchPartner(partnerId);
    }
  }, [partnerId, setSelectedPartnerId, switchPartner]);

  const partnerOptions = useMemo(
    () =>
      carehomePartnerList.map(data => ({ value: data.id, label: data.name })),
    [carehomePartnerList]
  );

  const handlePartnerChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newPartnerId = e.target.value;
    setSelectedPartnerId(newPartnerId);
    switchPartner(newPartnerId);
  };

  const isPatientRoute =
    location.pathname.startsWith('/new-patient') ||
    location.pathname.startsWith('/patient/');

  if (error) {
    return <div>...</div>;
  }

  return (
    <div>
      {isPatientRoute ? (
        <a
          className="govuk-header__link"
          href="#"
          onClick={e => e.preventDefault()}
        >
          {
            partnerOptions?.find(option => option.value === selectedPartnerId)
              ?.label
          }
        </a>
      ) : (
        <select
          className="govuk-select carehome-partner-select n:text-right"
          id="carehome-partner-list"
          name="carehome-partner-list"
          value={selectedPartnerId ?? ''}
          onChange={handlePartnerChange}
        >
          {partnerOptions?.map(option => (
            <option
              value={option.value}
              className="govuk-header__link"
              key={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default CareHomePartnerList;
